import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "@unibuddy/intl";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_VIEWS} from "../../../../translations/blogs";

const NumberOfViews = ({count, minimumToShow}) => {
    const {t} = useTranslation(IntlNamespaces.BLOGS);

    if (count < minimumToShow) {
        return null;
    }

    return (
        <span>
            {count} {t(INTL_VIEWS.key, INTL_VIEWS.defaultValue)}
        </span>
    );
};

NumberOfViews.defaultProps = {
    minimumToShow: 10,
};

NumberOfViews.propTypes = {
    count: PropTypes.number.isRequired,
    minimumToShow: PropTypes.number,
};

export default NumberOfViews;
